/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { MoneyWalletAOpenIcon16Light } from './MoneyWalletAOpenIcon16Light';
import { MoneyWalletAOpenIcon16Regular } from './MoneyWalletAOpenIcon16Regular';
import { MoneyWalletAOpenIcon16Solid } from './MoneyWalletAOpenIcon16Solid';
import { MoneyWalletAOpenIcon20Light } from './MoneyWalletAOpenIcon20Light';
import { MoneyWalletAOpenIcon20Regular } from './MoneyWalletAOpenIcon20Regular';
import { MoneyWalletAOpenIcon20Solid } from './MoneyWalletAOpenIcon20Solid';
import { MoneyWalletAOpenIcon24Regular } from './MoneyWalletAOpenIcon24Regular';
import { MoneyWalletAOpenIcon24Solid } from './MoneyWalletAOpenIcon24Solid';
import { MoneyWalletAOpenIcon32Regular } from './MoneyWalletAOpenIcon32Regular';
import { MoneyWalletAOpenIcon64Regular } from './MoneyWalletAOpenIcon64Regular';
var sizes = {
    16: {
        light: MoneyWalletAOpenIcon16Light,
        regular: MoneyWalletAOpenIcon16Regular,
        solid: MoneyWalletAOpenIcon16Solid,
    },
    20: {
        light: MoneyWalletAOpenIcon20Light,
        regular: MoneyWalletAOpenIcon20Regular,
        solid: MoneyWalletAOpenIcon20Solid,
    },
    24: {
        regular: MoneyWalletAOpenIcon24Regular,
        solid: MoneyWalletAOpenIcon24Solid,
    },
    32: {
        regular: MoneyWalletAOpenIcon32Regular,
    },
    64: {
        regular: MoneyWalletAOpenIcon64Regular,
    },
};
export var MoneyWalletAOpenIcon = forwardRef('MoneyWalletAOpenIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
